import App from './App.svelte';

const element = document.getElementById('alvarium-trainings-app');
const app = new App({
	target: element,
	props: element.dataset
});

export default app;
